import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/api";

const ENDPOINT = "/api/v1/cc/nursing_care/transportation_fee";

export const fetchTransportationFee = createAsyncThunk(
  "transportationFee/fetchTransportationFee",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(ENDPOINT);
      return response?.data?.data?.fee;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Error fetching transportation fee"
      );
    }
  }
);

export const updateTransportationFee = createAsyncThunk(
  "transportationFee/updateTransportationFee",
  async (body, { rejectWithValue }) => {
    try {
      const response = await api.post(ENDPOINT, body);
      return response?.data?.data?.fee;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Error updating transportation fee"
      );
    }
  }
);

